import './applied_grouped_elements_view.js.coffee'

Namespace 'Common.Dashboard.Filters'

FILTERS = Common.Dashboard.Filters

class Common.Dashboard.Filters.AppliedExcludedGroupedElementsView extends FILTERS.AppliedGroupedElementsView

  initialize: ({filter, isReadOnly}) ->
    super({filter, titleClassName: 'label-danger', isReadOnly})

  _displayTitle: ->
    'EXCLUDE'

  _displayValues: ->
    @_mapValues(@filter.getValues()?.excluded?.values || [])
